<template>
    <div>
        <div v-if="admin_data.pf || admin_data.collective || admin_data.dedicated || admin_data.ivr || admin_data.profit || admin_data.marketingProfit">
            <div>
                <ul class="nav nav-pills" role="tablist">
                    <li v-if="admin_data.pf" class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#admin_data_pf" role="tab" aria-selected="false">
                            {{ $t('dashboard.label.dedicated') }}
                        </a>
                    </li>
<!--                    <li v-if="admin_data.collective" class="nav-item">-->
<!--                        <a class="nav-link" data-toggle="tab" href="#admin_data_collective" role="tab" aria-selected="false">-->
<!--                            {{ $t('dashboard.label.payment_facilitator') }}-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li v-if="admin_data.dedicated" class="nav-item">-->
<!--                        <a class="nav-link" data-toggle="tab" href="#admin_data_dedicated" role="tab" aria-selected="false">-->
<!--                            {{ $t('dashboard.label.direct') }}-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li v-if="admin_data.ivr" class="nav-item">-->
<!--                        <a class="nav-link" data-toggle="tab" href="#admin_data_ivr" role="tab" aria-selected="false">-->
<!--                            {{ $t('dashboard.label.ivr') }}-->
<!--                        </a>-->
<!--                    </li>-->
                    <li v-if="admin_data.profit && admin_data.marketingProfit" class="nav-item">
                      <a class="nav-link" :class="{ 'active': (!admin_data.pf) }" data-toggle="tab" href="#company_profit_data" role="tab" aria-selected="false">
                        {{ $t('dashboard.label.company_profit') }}
                      </a>
                    </li>
                </ul>
            </div>
            <div class="tab-content">
                <div v-if="admin_data.pf" id="admin_data_pf" class="tab-pane active">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-oryelo">
                                        <div class="card-body">
                                            {{ $t('label.last_updated') }}
                                            <h5 class="fix-margin" style="direction: ltr">
                                                {{ admin_data.last_update }}
                                            </h5>
                                        </div>
<!--                                        <div class="position-absolute" style="left:20px;top:13px;cursor: pointer;">-->
<!--                                            <button class="no-border" @click="refreshData()" >-->
<!--                                                <i class="fa flaticon-refresh" aria-hidden="true"-->
<!--                                                   style="font-size: 1.6em; color: papayawhip"-->
<!--                                                   :title="$t('btn.update')"-->
<!--                                                >-->
<!--                                                </i>-->
<!--                                            </button>-->
<!--                                        </div>-->
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-oryelo">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.daily_transactions') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.today_tr }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-grass">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.monthly_transactions') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.monthly_tr }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-bluvio">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.total_transactions') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.total_tr }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-ored ">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.balance') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.balance }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-midivio">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.settling_balance') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.settling }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-pinkp">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.settled_balance') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.settled }}
                                                <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card mb-3 bg-gr-viop">
                                        <div class="card-body">
                                            {{ $t('dashboard.label.settling_count') }}
                                            <h5 class="fix-margin">
                                                {{ admin_data.pf.settling_count }}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div v-if="admin_data.collective" id="admin_data_collective" class="tab-pane">-->
<!--                    <div class="panel panel-default">-->
<!--                        <div class="panel-body">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-oryelo">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.daily_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.today_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-grass">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.monthly_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.monthly_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-bluvio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.total_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.total_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-ored ">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.balance }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-midivio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.settling }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-pinkp">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settled_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.settled }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-viop">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_count') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.collective.settling_count }}-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-if="admin_data.dedicated" id="admin_data_dedicated" class="tab-pane">-->
<!--                    <div class="panel panel-default">-->
<!--                        <div class="panel-body">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-oryelo">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.daily_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.today_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-grass">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.monthly_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.monthly_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-bluvio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.total_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.total_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-ored ">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.balance }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-midivio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.settling }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-pinkp">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settled_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.settled }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-viop">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_count') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.dedicated.settling_count }}-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-if="admin_data.ivr" id="admin_data_ivr" class="tab-pane">-->
<!--                    <div class="panel panel-default">-->
<!--                        <div class="panel-body">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-oryelo">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.daily_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.today_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-grass">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.monthly_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.monthly_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="card mb-3 bg-gr-bluvio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.total_transactions') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.total_tr }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-ored ">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.balance }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-midivio">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.settling }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-pinkp">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settled_balance') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.settled }}-->
<!--                                                <span style="font-size: 1.2rem">-->
<!--                                                    {{' ' + $t('currency.rial')}}-->
<!--                                                </span>-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-3">-->
<!--                                    <div class="card mb-3 bg-gr-viop">-->
<!--                                        <div class="card-body">-->
<!--                                            {{ $t('dashboard.label.settling_count') }}-->
<!--                                            <h5 class="fix-margin">-->
<!--                                                {{ admin_data.ivr.settling_count }}-->
<!--                                            </h5>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                  <div v-if="admin_data.ivr_profit" class="row">-->
<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-ored">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.ivr_daily_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.ivr_profit.daily }}-->
<!--                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-ored">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.ivr_monthly_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.ivr_profit.monthly }}-->
<!--                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-ored">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.ivr_total_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.ivr_profit.total }}-->
<!--                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="line-divider mb-3 mt-3"></div>-->
<!--                  </div>-->
<!--                </div>-->
                <div v-if="admin_data.profit" id="company_profit_data" class="tab-pane" :class="{ 'active': (!admin_data.pf) }">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-ored">
                        <div class="card-body">
                          {{ $t('dashboard.label.daily_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.daily }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-ored">
                        <div class="card-body">
                          {{ $t('dashboard.label.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-ored">
                        <div class="card-body">
                          {{ $t('dashboard.label.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-oryelo">
                        <div class="card-body">
                          {{ $t('dashboard.label.daily_net_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.dailyNet }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-oryelo">
                        <div class="card-body">
                          {{ $t('dashboard.label.monthly_net_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.monthlyNet }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-oryelo">
                        <div class="card-body">
                          {{ $t('dashboard.label.total_net_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.profit.totalNet }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.marketing.daily_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.marketingProfit.daily }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.marketing.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.marketingProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.marketing.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.marketingProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4" v-if="admin_data.openBankingMarketingProfit">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.openBankingMarketing.daily_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.openBankingMarketingProfit.daily }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4" v-if="admin_data.openBankingMarketingProfit">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.openBankingMarketing.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.openBankingMarketingProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4" v-if="admin_data.openBankingMarketingProfit">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.openBankingMarketing.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.openBankingMarketingProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>

<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-midivio">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.marketing_type_2.daily_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.affiliateMarketingChargeData.daily }}-->
<!--                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-midivio">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.marketing_type_2.monthly_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.affiliateMarketingChargeData.monthly }}-->
<!--                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4">-->
<!--                      <div class="card mb-3 bg-gr-midivio">-->
<!--                        <div class="card-body">-->
<!--                          {{ $t('dashboard.label.marketing_type_2.total_profit') }}-->
<!--                          <h5 class="fix-margin">-->
<!--                            {{ admin_data.affiliateMarketingChargeData.total }}-->
<!--                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-viop">
                        <div class="card-body">
                          {{ $t('dashboard.label.wallet_profit.daily_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.walletProfit.daily }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-viop">
                        <div class="card-body">
                          {{ $t('dashboard.label.wallet_profit.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.walletProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-viop">
                        <div class="card-body">
                          {{ $t('dashboard.label.wallet_profit.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.walletProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.open_banking.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.openBankingProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-bluvio">
                        <div class="card-body">
                          {{ $t('dashboard.label.open_banking.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.openBankingProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-pinkp">
                        <div class="card-body">
                          {{ $t('dashboard.label.sms_wallet_charging.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.smsWalletChargeProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-pinkp">
                        <div class="card-body">
                          {{ $t('dashboard.label.sms_wallet_charging.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.smsWalletChargeProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-ored">
                        <div class="card-body">
                          {{ $t('dashboard.label.online_contract.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.onlineContractProfit.monthly }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="card mb-3 bg-gr-ored">
                        <div class="card-body">
                          {{ $t('dashboard.label.online_contract.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.onlineContractProfit.total }}
                            <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-berry">
                        <div class="card-body">
                          {{ $t('dashboard.label.net_profit.daily_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.netProfit.daily }}
                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-berry">
                        <div class="card-body">
                          {{ $t('dashboard.label.net_profit.monthly_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.netProfit.monthly }}
                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card mb-3 bg-gr-berry">
                        <div class="card-body">
                          {{ $t('dashboard.label.net_profit.total_profit') }}
                          <h5 class="fix-margin">
                            {{ admin_data.netProfit.total }}
                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="line-divider mb-3 mt-3"></div>
                  </div>
                </div>
            </div>


            <div class="line-divider mb-3"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "admin_data",

        props: {
            admin_data: {
                default() {
                    return {}
                }
            },
        },
        methods :{
            refreshData() {
                this.$store.dispatch('dashboard/refreshDashboard');
            }
        }
    }
</script>

<style>
    .line-divider {
        height: 1px;
        background-color: #777;
    }
</style>